import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
@Component({
  selector: 'app-r-title',
  templateUrl: './r-title.component.html',
  styles: [``],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RTitleComponent),
      multi: true
    }
  ]
})
export class RTitleComponent extends RenderComponentBase {
  static KEY = 'r-d-title';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.paddingLeft !== 'string') {
      config.paddingLeft = '10px';
    }
    if (typeof config.fontSize !== 'string') {
      config.fontSize = '18px';
    }
    if (typeof config.color !== 'string') {
      config.color = '#000000';
    }
    if (typeof config.weight !== 'number') {
      config.weight = '400';
    }
  }
}
